import axios from "axios";
import React, { useEffect, useState } from "react";
import Icon1 from "../Assets/img/at-glance-icon/icon-1.svg";

const Glance = () => {
  const [glanceDetails, setGlanceDetails] = useState([]);

  useEffect(() => {
    axios.get("JSON/glance.json").then((response) => {
      setGlanceDetails(response.data[0]);
    });
  }, []);
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
          <div className="section-head">
            <h3 className="section-head-title">
              {glanceDetails?.section_title}
            </h3>
            <p className="section-head-text">{glanceDetails?.section_detail}</p>
          </div>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-12 col-xl-6 col-12">
          <div className="eschool-at-glance-content">
            <div className="eschool-at-glance-content-top">
              <h4 className="eschool-at-glance-cont-title">
                {glanceDetails?.achievement_section?.achievement_title}
              </h4>
              <p className="eschool-at-glance-cont-text">
                {glanceDetails?.achievement_section?.achievement_detail}
              </p>
            </div>
            <div className="eschool-at-glance-content-bottom">
              <div className="row">
                {glanceDetails?.achievement_section?.achievements?.map(
                  (achievement) => (
                    <div
                      className="col-lg-6 col-xl-4 col-md-4 col-12"
                      key={achievement?.id}
                    >
                      <div className="eschool-at-glance-card">
                        <div className="eschool-at-glance-card-icon">
                          <img src={Icon1} alt="#" />
                        </div>
                        <h5 className="eschool-at-glance-card-year">
                          {achievement?.year}
                        </h5>
                        <p className="eschool-at-glance-card-text">
                          {achievement?.title}
                        </p>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6 col-12">
          <div className="eschool-at-glance-img">
            <img src={glanceDetails?.img} alt="#" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Glance;
